import React from 'react';
import { translate } from '../../Services/translation';
import { useSelector, useDispatch } from 'react-redux';
import { toggle, clearCart } from '../Actions/OfferCart.action';

const OfferMiniCart = () => {
    const dispatch = useDispatch();
    const { quantity, checkoutUrl, showInfo } = useSelector(
        (state) => state.offerCart
    );
    const onToggle = () => dispatch(toggle());

    const clear = () => {
        if (confirm(translate('code.minicart.clear.confirm'))) {
            dispatch(clearCart());
            dispatch(toggle());
        }
    }

    return (
        <div className="cart cart--mini">
            <a className="cart__link--block" onClick={() => onToggle()}>
                <i className="cart__icon">
                    <span className="cart__quantity">{quantity}</span>
                </i>
                <span className="cart__title">
                    {translate('minicart.checkout')}
                </span>
            </a>
            <div
                className={`cart__info ${
                    !showInfo ? 'cart__info--hidden' : ''
                }`}
            >
                <p className="cart__info-title sub-heading__small">
                    {translate('code.minicart.info.title')}
                </p>
                <span
                    className="cart__close-button"
                    onClick={() => onToggle()}
                >x</span>
                <p className="cart__info-row">
                    {quantity} {translate('minicart.numberofproduct')}
                {quantity>0 &&
                    <span className="simple-table" title={translate('general.remove')}><span className="table__icon table__icon--delete-white" onClick={() => clear()}></span></span>
                }
                </p>
                <a href={checkoutUrl} className="cart__checkout-button">
                    {translate('code.minicart.checkout.button')}
                </a>
            </div>
        </div>
    );
};

export default OfferMiniCart;
